import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  computed,
  ElementRef,
  input,
  Input,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-link-to',
  templateUrl: './link-to.component.html',
  styleUrls: ['./link-to.component.scss'],
  standalone: false,
})
export class LinkToComponent implements AfterViewInit {
  readonly label = input<string>('');
  readonly url = input<string>('');
  readonly id = input<string | undefined>(undefined);

  // Signal computed : id "valid"
  readonly hasValidId = computed(() => {
    const value = this.id();

    // normalization
    if (!value) return false; // undefined, null, ''
    const trimmed = value.trim(); // remove spaces

    // "0" is invalid"
    return trimmed !== '' && trimmed !== '0';
  });

  protected overMaxSize: boolean = false;
  @ViewChild('mdi') mdiElement!: ElementRef;

  constructor(private readonly changeDetectorRef: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    //Get mdi values
    const element = this.mdiElement.nativeElement;
    const computedFontSize = parseFloat(getComputedStyle(element).fontSize);

    //Get max size wanted based on css
    const rootStyles = getComputedStyle(document.documentElement);
    const fontSizeBase = rootStyles.getPropertyValue('--font-size-base').trim();

    const temp = document.createElement('div');
    temp.style.fontSize = fontSizeBase;
    document.body.appendChild(temp);
    const maxPixelValue = parseFloat(getComputedStyle(temp).fontSize);
    document.body.removeChild(temp);

    this.overMaxSize = computedFontSize > maxPixelValue;

    this.changeDetectorRef.detectChanges();
  }
}
